const REASON_CODE_TEXT = Object.freeze({
  SELECT_A_REASON: "Select A Reason",
  SATISFACTORY: "Satisfactory",
  POTENTIAL_ISSUE: "Potential Issue",
  TROUBLESHOOTING_NEEDED: "Troubleshooting needed",
  FOLLOW_UP_REQUIRED: "Follow up required",
  OUT_OF_THRESHOLD: "Out of Threshold",
  UNPLANNED_EVENT_OCCURRED: "Unplanned event occurred",
  ASSET_INOPERABLE_BROKEN: "Asset Inoperable/broken",
  OTHER_MAJOR_ISSUE: "Other Major Issue",
  ASSET_OBSTRUCTED: "Asset Obstructed",
  UNABLE_TO_COMPLETE: "Unable to Complete",
  ASSET_NOT_FOUND: "Asset not Found",
});

const REASON_CODE_NUMBER_TO_TEXT = Object.freeze({
  0: REASON_CODE_TEXT.SELECT_A_REASON,
  // pass --------------------------------------------------
  101: REASON_CODE_TEXT.SATISFACTORY,
  // warn --------------------------------------------------
  201: REASON_CODE_TEXT.POTENTIAL_ISSUE,
  202: REASON_CODE_TEXT.TROUBLESHOOTING_NEEDED,
  203: REASON_CODE_TEXT.FOLLOW_UP_REQUIRED,
  // fail --------------------------------------------------
  301: REASON_CODE_TEXT.OUT_OF_THRESHOLD,
  302: REASON_CODE_TEXT.UNPLANNED_EVENT_OCCURRED,
  303: REASON_CODE_TEXT.ASSET_INOPERABLE_BROKEN,
  304: REASON_CODE_TEXT.OTHER_MAJOR_ISSUE,
  // skip --------------------------------------------------
  401: REASON_CODE_TEXT.ASSET_OBSTRUCTED,
  402: REASON_CODE_TEXT.UNABLE_TO_COMPLETE,
  403: REASON_CODE_TEXT.ASSET_NOT_FOUND,
});

const DEFAULT_REASON_CODE = 0;

module.exports = {
  REASON_CODE_TEXT,
  REASON_CODE_NUMBER_TO_TEXT,
  DEFAULT_REASON_CODE,
  getReasonCodeText: (reasonCodeNumber) =>
    reasonCodeNumber in REASON_CODE_NUMBER_TO_TEXT
      ? REASON_CODE_NUMBER_TO_TEXT[reasonCodeNumber]
      : REASON_CODE_TEXT.SELECT_A_REASON,
};
